import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // JWT verification validation
  if (properties.action === 'verifyJwt') {
    if (!properties.jwtToken) {
      errors.push({
        key: 'jwtToken',
        message: 'JWT token is required'
      });
    }

    if (!properties.jwtSecretOrKey) {
      errors.push({
        key: 'jwtSecretOrKey',
        message: 'Secret or public key is required'
      });
    }

    if (properties.jwtValidateIssuer && !properties.jwtIssuer) {
      errors.push({
        key: 'jwtIssuer',
        message: 'Expected issuer is required when issuer validation is enabled'
      });
    }

    if (properties.jwtValidateAudience && !properties.jwtAudience) {
      errors.push({
        key: 'jwtAudience',
        message: 'Expected audience is required when audience validation is enabled'
      });
    }
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
